import retrieveDaqsJson from './retrieve-daqs-json'
import tableAdapter from './tableAdapter'
import boatBins from './filters/boatBins'
import { components } from '@datavue/datavue-ui'
import states from './filters/states'
const ChloroplethHeatmap = () =>
  import('../components/charts/ChloroplethHeatmap')
const HorizontalBarchart = () =>
  import('../components/charts/HorizontalBarchart')
const GenericPage = () => import('@/components/pages/GenericPage')
const DaqsChart = () => import('@/components/DaqsChart')
export default class Accidents {
  title = 'Recreational Boating Accident and Risk Ratios'
  key = 'accidents'
  pageComponent = GenericPage
  retrieveData = retrieveDaqsJson
  filters = function () {
    return {
      question: {
        key: 'question',
        label: 'View results for the risk ratio:',
        component: components['DatavueUiSelect'],
        options: [
          {
            key: 'accidents_involving',
            label: 'Accidents Involving',
            default: true
          },
          {
            key: 'cases_of',
            label: 'Cases Of'
          }
        ],
        afterSet (action, dv) {
          dv.setOptionsForFilter('metric', options[dv.getFilter('question')])
        }
      },
      filter1boatbin: {
        label: 'Boat Category:',
        component: components['DatavueUiSelect'],
        options: boatBins
      },
      filter2state: {
        label: 'State of Operation:',
        component: components['DatavueUiSelect'],
        options: states
      },
      metric: {
        label: 'Report exposure as:',
        component: components['DatavueUiRadioGroup'],
        props: {
          inline: true
        },
        options: options['accidents_involving']
      }
    }
  }
  charts = function () {
    return {
      overall_fatalities: {
        title: 'Fatalities',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: {},
          grid: 'overall'
        }
      },
      state_fatalities: {
        title: 'Fatalities By State of Operation',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: ChloroplethHeatmap,
          mapType: 'state',
          tableAdapter: tableAdapter,
          tableLabel: 'State of Operation',
          grid: ''
        }
      },
      boatbin_fatalities: {
        title: 'Fatalities By Boat Category',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          tableAdapter: tableAdapter,
          tableLabel: 'Boat Category',
          grid: ''
        }
      },
      overall_injuries: {
        title: 'Injuries',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: {},
          grid: 'overall'
        }
      },
      state_injuries: {
        title: 'Injuries By State of Operation',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: ChloroplethHeatmap,
          mapType: 'state',
          tableAdapter: tableAdapter,
          tableLabel: 'State of Operation',
          grid: ''
        }
      },
      boatbin_injuries: {
        title: 'Injuries By Boat Category',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          tableAdapter: tableAdapter,
          grid: '',
          tableLabel: 'Boat Category'
        }
      },
      overall_casualties: {
        title: 'Casualties',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: {},
          grid: 'overall'
        }
      },
      state_casualties: {
        title: 'Casualties By State of Operation',
        component: DaqsChart,
        props: {
          card: false,
          grid: '',
          chartComponent: ChloroplethHeatmap,
          mapType: 'state',
          tableAdapter: tableAdapter,
          tableLabel: 'State of Operation'
        }
      },
      boatbin_casualties: {
        title: 'Casualties By Boat Category',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          grid: '',
          tableAdapter: tableAdapter,
          tableLabel: 'Boat Type'
        }
      }
    }
  }
}

let options = {
  'accidents_involving': [
    {
      key: 'per_100_million_boat_person_days',
      label: 'Average Boat Days',
      default: true
    },
    {
      key: 'per_100_million_boat_person_hours',
      label: 'Boat Hours'
    }
  ],
  'cases_of': [
    {
      key: 'per_100_million_boat_person_days',
      label: 'Average Boat Person Days',
      default: true
    },
    {
      key: 'per_100_million_boat_person_hours',
      label: 'Boat Person Hours'
    }
  ]
}
